<template>
  <Breadcrumbs title="Edit Profile" main="Users" />
  <div class="container-fluid">
    <div class="edit-profile">
      <div class="row">
        <InfoEvent :info="eventInfo" />
        <CertificationList @openModal="showModal" :list="list" />
      </div>
    </div>
  </div>
  <ModalUpload ref="thisModal" @refresh="getActiveTutor" @reload="closeModal" />
</template>
<script setup>
import { ref, onMounted } from "vue";
import InfoEvent from "./info_event.vue";
import CertificationList from "./certification_list.vue";
import axios from "@/includes/connection";

onMounted(async () => {
  await listTemplates();
  await getEventInfo();
});

const list = ref([]);
const eventInfo = ref({});

const listTemplates = async () => {
  await axios
    .get("/certification/legacy-participants-by-event/" + routeId)
    .then((response) => {
      console.log("test", response.data);
      list.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

const getEventInfo = async () => {
  await axios
    .get("/certification/event-info-legacy/" + routeId)
    .then((response) => {
      console.log("test", response.data);
      eventInfo.value = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};

// -- modal section
import ModalUpload from "./ModalUpload.vue";
let modal = null;
import { Modal } from "bootstrap";
let thisModal = ref(null);

const showModal = () => {
  console.log("open modal ................ ");
  const modalElement = thisModal.value.$el;
  modal = new Modal(modalElement);
  modal.show();
};

const closeModal = () => {
  if (modal) {
    listTemplates();
    modal.hide();
  }
};

//-----route section
import { useRoute } from "vue-router";

const route = useRoute();

// Access the route parameter
const routeId = route.params.id;
</script>
